<script>
import HeaderIntroVideo from './HeaderIntroVideo.svelte'

let visible = true
let visibilityChanged = d => {    
    visible = d.detail
}
</script>

<style>
.fullscreen{ position:absolute; top:0px; left:0px; width:100%; height:100%; z-index:0; }
.video{ position:absolute; top:0px; left:0px; width:100%; height:100%; }
.overlay{ z-index:1; }

@media (max-width: 768px){
    video.video{ width:auto; max-width:none; height:800px; margin-left:-90%; }
}
</style>

<div class="fullscreen">
    <video class="video loop" muted loop autoplay playsinline>
        <source src="./res/videos/brown-loop.webm" type="video/webm" />
        <source src="./res/videos/brown-loop.ogg" type="video/ogg" />
        <source src="./res/videos/brown-loop.mp4" type="video/mp4" />
        <img alt="Background image" src="./res/videos/brown.jpg">
    </video>

    {#if visible}
        <HeaderIntroVideo on:visible={visibilityChanged} />
    {/if}

    <div class="fullscreen overlay" style="background: linear-gradient(180deg, #090304 10%, rgba(0,0,0,0) 40%, rgba(0,0,0,0) 70%, #090304 80%);"></div>
</div>